import React from 'react';
import format from 'date-fns/format';
import { RiDownloadLine } from 'react-icons/ri';

import { Button, TableRow, TableCell } from '@unimed-fesp/components';

import theme from '../../../styles/theme';
import { ButtonLink } from './styles';

const TableBodyRelatorios = ({ relatorios }) => {
  return (
    <>
      {relatorios.map((relatorio) => {
        const EM_ANDAMENTO =
          relatorio.status?.toLocaleUpperCase() ===
          'Em andamento'?.toLocaleUpperCase();

        return (
          <TableRow>
            <TableCell>
              {relatorio.nome ? (
                <ButtonLink onClick={relatorio.urlDownload}>
                  {relatorio.nome}
                </ButtonLink>
              ) : (
                '-'
              )}
            </TableCell>
            <TableCell>{relatorio.status || '-'}</TableCell>
            <TableCell>
              {relatorio.dataInclusao
                ? format(new Date(relatorio.dataInclusao), 'dd/MM/yyyy HH:mm', {
                    timeZone: 'America/Sao_Paulo',
                  })
                : '-'}
            </TableCell>
            <TableCell>
              {relatorio.dataProcessamento
                ? format(
                    new Date(relatorio.dataProcessamento),
                    'dd/MM/yyyy HH:mm',
                    {
                      timeZone: 'America/Sao_Paulo',
                    }
                  )
                : '-'}
            </TableCell>
            <TableCell>
              <Button
                width={50}
                padding={5}
                justifyCenter
                disabled={EM_ANDAMENTO}
                onClick={relatorio.urlDownload}
                marginLeft={10}
              >
                <RiDownloadLine color={theme.white} size={20} />
              </Button>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default TableBodyRelatorios;
